module.exports = __webpack_public_path__ + "static/media/dropdown_icon.519a01a9.svg";